var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 0.625H1.375C0.960156 0.625 0.625 0.960156 0.625 1.375V18.625C0.625 19.0398 0.960156 19.375 1.375 19.375H18.625C19.0398 19.375 19.375 19.0398 19.375 18.625V1.375C19.375 0.960156 19.0398 0.625 18.625 0.625ZM6.18672 16.6023H3.40469V7.65391H6.18672V16.6023ZM4.79688 6.43047C4.47795 6.43047 4.16619 6.3359 3.90102 6.15871C3.63584 5.98153 3.42917 5.72969 3.30712 5.43505C3.18507 5.1404 3.15314 4.81618 3.21536 4.50339C3.27758 4.19059 3.43115 3.90327 3.65667 3.67776C3.88218 3.45225 4.1695 3.29867 4.48229 3.23645C4.79509 3.17423 5.11931 3.20617 5.41395 3.32821C5.7086 3.45026 5.96044 3.65694 6.13762 3.92211C6.3148 4.18729 6.40937 4.49905 6.40937 4.81797C6.40703 5.70859 5.68516 6.43047 4.79688 6.43047ZM16.6023 16.6023H13.8227V12.25C13.8227 11.2117 13.8039 9.87812 12.3766 9.87812C10.9305 9.87812 10.7078 11.0078 10.7078 12.175V16.6023H7.93047V7.65391H10.5977V8.87734H10.6352C11.0055 8.17422 11.9125 7.43125 13.2672 7.43125C16.0844 7.43125 16.6023 9.28516 16.6023 11.6945V16.6023Z",
    fill: "#B3B3B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLinkedin);
export default __webpack_public_path__ + "static/media/newLinkedin.d12f879c58f2e4ccc3992db3319d09e6.svg";
export { ForwardRef as ReactComponent };